// ? optional fields are specified with "null"
export default {
  basicDetails: {
    defaultValues: {
      cost_centre: "",
      supervisor_email: "",
      representation_id: null,
      additional_acceptor_email: null,
      advance_payment: null,
      attachments: [],
      ocr_attachments: [],
      comments: "",
      type: "",
      accommodation_payment_type: null,
      person_responsible: null,
      status: null,
    },
    accomodationOptionsEnum: {
      User: "Self",
      BookingTool: "Cwt",
    },
    additionalAcceptanceFieldStateDefaultValues: {
      open: false,
      disabled: false,
    },
  },
};
